type QueryFnParam<P extends unknown[]> = {
  params: P
  signal?: AbortSignal
}

export type QueryFn<P extends unknown[], R> = (param: QueryFnParam<P>) => Promise<R>
export type MutateFn<P extends unknown[], R> = (...args: P) => Promise<R>
export const dsApiBasePath = '/hcem/ui'
